import React from 'react';
import Contact from "./ContactNew";
import MaterialComparison from "./MaterialComparison";
import styled from 'styled-components';
import Videos from "./home/Videos";
import Hero from "./home/Hero";
import Epdm from "./home/Epdm";
import Advantages from "./home/Advantages";
import FlashingTech from "./home/FlashingTech";
import Footer from "./home/Footer";
import Navbar from "./home/Navbar";
import GlobalStyle from "../styles/GlobalStyle";

const Main = styled.main`
    padding-top: 70px; /* компенсира фиксирания navbar */
    width: 100%;
`;

const SectionWide = styled.section`
    margin: 0 auto;
    max-width: 1200px;
`;

const Section = styled.section`
    padding: 72px 20px;
    margin: 0 auto;
    max-width: 1200px;
`;

export default function HomePage() {

    return (
        <>
            <GlobalStyle/>
            <Navbar/>
            <Main>
                <Hero/>
                <Section id="epdm">
                    <Epdm/>
                </Section>
                <SectionWide id="video">
                    <Videos/>
                </SectionWide>
                <Section id="accessories">
                    <FlashingTech/>
                </Section>
                <SectionWide id="comparison">
                    <MaterialComparison/>
                </SectionWide>
                <Advantages/>
                <Section id="contact">
                    <Contact/>
                </Section>
                <Footer/>
            </Main>
        </>
    );
}
